// extracted by mini-css-extract-plugin
export default {"contactForm":"ContactForm_contactForm__-q-YQ","contactFormHeading":"ContactForm_contactFormHeading__D4fm8","contactFormSubHeading":"ContactForm_contactFormSubHeading__3Uu7d"};